import React from 'react';
import { apiFetch } from './fetchApi';

export const TestFetchOverAllStatus = (BeURL, setOverAllStatus) => {
    apiFetch(`${BeURL}/fecth-overall-status`, {
        method: 'GET',
        
    })
        .then((res) => res.json())
        .then((data) => {
            setOverAllStatus(data.data)
        })
        .catch((err) => {
            console.log("Error in fetch user", err);
        });
};
